import React, { useState } from "react"; 
import productImage from "../component/img/p1.jpeg";
import thumb1 from "../component/img/p2.webp";
import thumb2 from "../component/img/p3.webp";
import thumb3 from "../component/img/p4.webp";
import instock from "../component/img/instock.png";
import pay1 from "../component/img/pay1.png";
import { ChevronRight, ShoppingCart} from "react-feather";
import ProductReview from "../component/ProductReview";
import ProductCards from "../component/ProductCards";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";

import axios from "axios"; // Import axios
 

const ProductDetailtwo = () => {
  const [selectedImage, setSelectedImage] = useState(productImage);




  return (
    <>
    <VisitorNavbar/>
    <div className="container mt-3">

        <div className="text-start brdcrm1 mb-3">
            <span>Home</span>
            <span><ChevronRight size={12} /></span>
            <span>Category</span>
            <span><ChevronRight size={12} /></span>
            <span>SubCategory</span>
            <span><ChevronRight size={12} /></span>
            <span>Brand</span>
            <span><ChevronRight size={12} /></span>
            <span>ProductType</span> 
        </div>
      <div className="row">
        {/* Product Image Section */}
        <div className="col-md-6">
            <div className="box_detail">
            <div className="main-image">
            <img
              src={selectedImage}
              alt="Product"
              className="img-fluid border rounded"
            />
          </div>
          <div className="thumbnails d-flex mt-3">
            {[thumb1, thumb2, thumb3].map((thumb, index) => (
              <img
                key={index}
                src={thumb}
                alt={`Thumbnail ${index + 1}`}
                className="img-thumbnail me-2"
                style={{ width: "70px", cursor: "pointer" }}
                onClick={() => setSelectedImage(thumb)}
              />
            ))}
          </div>
            </div>
          
        </div>

        {/* Product Details Section */}
        <div className="col-md-6 text-start">
            <h5 className="brand-name">Bruker Motherboard</h5>
          <h2 className="product-name">Bruker Motherboard BOD ATTMA-1B ABC #75564 BOD GTMP-2C ABCDE</h2>
          
          <div className="d-flex">
            <span className="inr">&#8377;</span>
            <span className="priceproduct">2,000</span>
          </div>

          <div className="">
            <span className="mrp1">M.R.P.:&nbsp;</span>
            <span className="mrp2">&#8377;2,500</span>
          </div>

          <div className="">
            <span className="instock"><img src={instock} className="img-fluid instockimg me-1"/>In Stock</span> 
          </div>


            <div>
            <button className="add-to-cart-btn mt-3"><ShoppingCart size={19}/>&nbsp;Add to Cart</button>
            </div>



            <table className="table1">
    <tr>
        <td className="td1">Brand / Maker</td>
        <td className="td2">Bruker / Maldi TOF MS/MS</td>
    </tr>
    <tr>
        <td className="td1">Product Type</td>
        <td className="td2">Spares / Old Used</td>
    </tr>
    <tr>
        <td className="td1">Part Number</td>
        <td className="td2">75552.00041-I,  249005/0804,  
        26659.00573, 196609/0904</td>
    </tr>
    <tr>
        <td className="td1">Product Status</td>
        <td className="td2">Not Checked As where as basis. Both Mother board Attached Each Other.</td>
    </tr>
    
</table>


<hr/>

<div className="text-center pay1cls">
    <img src={pay1} className="img-fluid"/>
    <div className="payttl">Guaranteed Safe And Secure Checkout</div>
</div>

 
 <div>
    <h3 className="product-desc-title">Description</h3>

    <p className="product-desc">This premium tool set is designed for professional and home use. It
            includes a wide range of tools crafted from high-quality materials to
            ensure durability and precision. Ideal for repairs, DIY projects, and
            maintenance tasks.
            This premium tool set is designed for professional and home use. It
            includes a wide range of tools crafted from high-quality materials to
            ensure durability and precision. Ideal for repairs, DIY projects, and
            maintenance tasks.
            This premium tool set is designed for professional and home use. It
            includes a wide range of tools crafted from high-quality materials to
            ensure durability and precision. Ideal for repairs, DIY projects, and
            maintenance tasks.
            </p>
            
 </div>

 <hr/>


<div>
<h3 className="product-desc-title">Other Details</h3>
<table className="table1">
    <tr>
        <td className="td1">Brand / Maker</td>
        <td className="td2">Bruker / Maldi TOF MS/MS</td>
    </tr>
    <tr>
        <td className="td1">Product Type</td>
        <td className="td2">Spares / Old Used</td>
    </tr>
    <tr>
        <td className="td1">Part Number</td>
        <td className="td2">75552.00041-I,  249005/0804,  
        26659.00573, 196609/0904</td>
    </tr>
    <tr>
        <td className="td1">Product Status</td>
        <td className="td2">Not Checked As where as basis. Both Mother board Attached Each Other.</td>
    </tr>
    
</table>
</div>



 
        </div>
      </div>

      {/* Product Description Section */}
      <div className="row mt-5">
        <ProductReview/>
      </div>


      <section className="py-5 px-2">
        <h1 className="txt1">Similar Products</h1>
        <p className="txt2 mb-4">
          There are many variations of passages of lorem Ipsum available
          believable.
        </p> 
        <div>
           <ProductCards/>
        </div>
      </section>


    </div>
<Footer/>
    </>
  );
};

export default ProductDetailtwo;
